import { formatReviewCount } from "../../constants/reviewCounts";

export default function CountBadge({ count = 0, className = "" }) {
  if (!count) return null;

  return (
    <span
      className={`inline-flex min-w-[20px] h-[20px] shrink-0 items-center justify-center rounded-full bg-[#FF420E] px-1.5 text-[10px] leading-none text-white yekanBold ${className}`.trim()}
    >
      {formatReviewCount(count, { compact: true })}
    </span>
  );
}
